export const MODELLI = [
    "SBA31 STANDARD 2+2",
    "SBA31 STANDARD 2+3",
    "SBA31 STANDARD 3+3",
    "SBA31 STANDARD 3+4",
    "SBA31 STANDARD 4+4",
    "SBA31 STANDARD 4+5",
    "SBA31 GRAN VOLUME 2+2",
    "SBA31 GRAN VOLUME 2+3",
    "SBA31 GRAN VOLUME 3+3",
    "SBA31 GRAN VOLUME 3+4",
    "SBA31 GRAN VOLUME 4+4",
    "SBA31 GRAN VOLUME 4+5",
    "SBA31 GV SEMIRIBASSATO 2+2",
    "SBA31 GV SEMIRIBASSATO 2+3",
    "SBA31 GV SEMIRIBASSATO 3+3",
    "SBA31 GV SEMIRIBASSATO 3+4",
    "SBA31 GV SEMIRIBASSATO 4+4",
    "SBA31 GV SEMIRIBASSATO 4+5",
    "SBA31 STD PIANI DIVISI 2+2+2",
    "SBA31 STD PIANI DIVISI 2+3 +3",
    "SBA31 STD PIANI DIVISI 3+3+3",
    "SBA31 STD PIANI DIVISI 3+4+4",
    "SBA31 GV PIANI DIVISI 2+2+2",
    "SBA31 GV PIANI DIVISI 2+3 +3",
    "SBA31 GV PIANI DIVISI 3+3+3",
    "SBA31 GV PIANI DIVISI 3+4+4",
    "SBA31 GV SR PIANI DIVISI 2+2+2",
    "SBA31 GV SR PIANI DIVISI 2+3 +3",
    "SBA31 GV SR PIANI DIVISI 3+3+3",
    "SBA31 GV SR PIANI DIVISI 3+4+4",
    "SBA31 STD PIANI DIVISI 2+2+2+2",
    "SBA31 STD PIANI DIVISI 2+3 +3+3",
    "SBA31 STD PIANI DIVISI 3+3+3+3",
    "SBA31 STD PIANI DIVISI 3+4+4+4",
    "SBA31 GV PIANI DIVISI 2+2+2+2",
    "SBA31 GV PIANI DIVISI 2+3+3+3",
    "SBA31 GV PIANI DIVISI 3+3+3+3",
    "SBA31 GV PIANI DIVISI 3+4+4+4",
    "SBA31 GV SR PIANI DIVISI 2+2+2+2",
    "SBA31 GV SR PIANI DIVISI 2+3 +3+3",
    "SBA31 GV SR PIANI DIVISI 3+3+3+3",
    "SBA31 GV SR PIANI DIVISI 3+4+4+4",
    "SBA32 STANDARD 2+2",
    "SBA32 STANDARD 2+3",
    "SBA32 STANDARD 3+3",
    "SBA32 STANDARD 3+4",
    "SBA32 STANDARD 4+4",
    "SBA32 STANDARD 4+5",
    "SBA32 GRAN VOLUME 2+2",
    "SBA32 GRAN VOLUME 2+3",
    "SBA32 GRAN VOLUME 3+3",
    "SBA32 GRAN VOLUME 3+4",
    "SBA32 GRAN VOLUME 4+4",
    "SBA32 GRAN VOLUME 4+5",
    "SBA32 GV SEMIRIBASSATO 2+2",
    "SBA32 GV SEMIRIBASSATO 2+3",
    "SBA32 GV SEMIRIBASSATO 3+3",
    "SBA32 GV SEMIRIBASSATO 3+4",
    "SBA32 GV SEMIRIBASSATO 4+4",
    "SBA32 GV SEMIRIBASSATO 4+5",
    "SBA32 STD PIANI DIVISI 2+2+2",
    "SBA32 STD PIANI DIVISI 2+3+3",
    "SBA32 STD PIANI DIVISI 3+3+3",
    "SBA32 STD PIANI DIVISI 3+4+4",
    "SBA32 STD PIANI DIVISI 4+4+4",
    "SBA32 GV PIANI DIVISI 2+2+2",
    "SBA32 GV PIANI DIVISI 2+3+3",
    "SBA32 GV PIANI DIVISI 3+3+3",
    "SBA32 GV PIANI DIVISI 3+4+4",
    "SBA32 GV PIANI DIVISI 4+4+4",
    "SBA32 GV SR PIANI DIVISI 2+2+2",
    "SBA32 GV SR PIANI DIVISI 2+3+3",
    "SBA32 GV SR PIANI DIVISI 3+3+3",
    "SBA32 GV SR PIANI DIVISI 3+4+4",
    "SBA32 GV SR PIANI DIVISI 4+4+4",
    "SBA32 STD PIANI DIVISI 2+2+2+2",
    "SBA32 STD PIANI DIVISI 3+3+3+3",
    "SBA32 STD PIANI DIVISI 3+4+4+4",
    "SBA32 STD PIANI DIVISI 4+4+4+4",
    "SBA32 GV PIANI DIVISI 2+2+2+2",
    "SBA32 GV PIANI DIVISI 3+3+3+3",
    "SBA32 GV PIANI DIVISI 3+4+4+4",
    "SBA32 GV PIANI DIVISI 4+4+4+4",
    "SBA32 GV SR PIANI DIVISI 2+2+2+2",
    "SBA32 GV SR PIANI DIVISI 3+3+3+3",
    "SBA32 GV SR PIANI DIVISI 3+4+4+4",
    "SBA32 GV SR PIANI DIVISI 4+4+4+4",
    "SBA62 CO STANDARD 2+2",
    "SBA62 CO STANDARD 2+3",
    "SBA62 CO STANDARD 3+3",
    "SBA62 CO STANDARD 3+4",
    "SBA62 CO GRAN VOLUME 2+2",
    "SBA62 CO GRAN VOLUME 2+3",
    "SBA62 CO GRAN VOLUME 3+3",
    "SBA62 CO GRAN VOLUME 3+4",
    "SBA62 CO STD PIANI DIVISI 2+2+2",
    "SBA62 CO STD PIANI DIVISI 2+3+3",
    "SBA62 CO STD PIANI DIVISI 3+3+3",
    "SBA62 CO STD PIANI DIVISI 3+4+4",
    "SBA62 CO STD PIANI DIVISI 4+4+4",
    "SBA62 CO GV PIANI DIVISI 2+2+2",
    "SBA62 CO GV PIANI DIVISI 2+3+3",
    "SBA62 CO GV PIANI DIVISI 3+3+3",
    "SBA62 CO GV PIANI DIVISI 3+4+4",
    "SBA62 CO GV PIANI DIVISI 4+4+4",
    "SBA62 CO STD PIANI DIVISI 2+2+2+2",
    "SBA62 CO STD PIANI DIVISI 3+3+3+3",
    "SBA62 CO STD PIANI DIVISI 3+4+4+4",
    "SBA62 CO STD PIANI DIVISI 4+4+4+4",
    "SBA62 CO GV PIANI DIVISI 2+2+2+2",
    "SBA62 CO GV PIANI DIVISI 3+3+3+3",
    "SBA62 CO GV PIANI DIVISI 3+4+4+4",
    "SBA62 CO GV PIANI DIVISI 4+4+4+4",
    "SBA62 STANDARD 2P",
    "SBA62 STANDARD 3P",
    "SBA62 STANDARD 4P",
    "SBA62 STANDARD 5P",
    "SBA62 GRAN VOLUME 2P",
    "SBA62 GRAN VOLUME 3P",
    "SBA62 GRAN VOLUME 4P",
    "SBA62 GRAN VOLUME 5P",
    "SBA63 CO STANDARD 2+2",
    "SBA63 CO STANDARD 2+3",
    "SBA63 CO STANDARD 3+3",
    "SBA63 CO STANDARD 3+4",
    "SBA63 CO GRAN VOLUME 2+2",
    "SBA63 CO GRAN VOLUME 2+3",
    "SBA63 CO GRAN VOLUME 3+3",
    "SBA63 CO GRAN VOLUME 3+4",
    "SBA63 CO STD PIANI DIVISI 2+2+2",
    "SBA63 CO STD PIANI DIVISI 2+3+3",
    "SBA63 CO STD PIANI DIVISI 3+3+3",
    "SBA63 CO STD PIANI DIVISI 3+4+4",
    "SBA63 CO GV PIANI DIVISI 2+2+2",
    "SBA63 CO GV PIANI DIVISI 2+3+3",
    "SBA63 CO GV PIANI DIVISI 3+3+3",
    "SBA63 CO GV PIANI DIVISI 3+4+4",
    "SBA63 CO STD PIANI DIVISI 2+2+2+2",
    "SBA63 CO STD PIANI DIVISI 3+3+3+3",
    "SBA63 CO STD PIANI DIVISI 3+4+4+4",
    "SBA63 CO STD PIANI DIVISI 4+4+4+4",
    "SBA63 CO GV PIANI DIVISI 2+2+2+2",
    "SBA63 CO GV PIANI DIVISI 3+3+3+3",
    "SBA63 CO GV PIANI DIVISI 3+4+4+4",
    "SBA63 CO GV PIANI DIVISI 4+4+4+4",
    "SBA63 STANDARD 2P",
    "SBA63 STANDARD 3P",
    "SBA63 STANDARD 4P",
    "SBA63 STANDARD 5P",
    "SBA63 GRAN VOLUME 2P",
    "SBA63 GRAN VOLUME 3P",
    "SBA63 GRAN VOLUME 4P",
    "SBA63 GRAN VOLUME 5P",
    "SBA63 STD PIANI DIVISI 2+2",
    "SBA63 STD PIANI DIVISI 3+3",
    "SBA63 STD PIANI DIVISI 4+4",
    "SBA63 GV PIANI DIVISI 2+2",
    "SBA63 GV PIANI DIVISI 3+3",
    "SBA63 GV PIANI DIVISI 4+4",
    "SBA63 STD PIANI DIVISI 2+2+2",
    "SBA63 STD PIANI DIVISI 3+3+3",
    "SBA63 STD PIANI DIVISI 4+4+4",
    "SBA63 GV PIANI DIVISI 2+2+2",
    "SBA63 GV PIANI DIVISI 3+3+3",
    "SBA63 GV PIANI DIVISI 4+4+4",
    "SBA63 STD PIANI DIVISI 2+2+2+2",
    "SBA63 STD PIANI DIVISI 3+3+3+3",
    "SBA63 STD PIANI DIVISI 3+4+4+4",
    "SBA63 STD PIANI DIVISI 4+4+4+4",
    "SBA63 GV PIANI DIVISI 2+2+2+2",
    "SBA63 GV PIANI DIVISI 3+3+3+3",
    "SBA63 GV PIANI DIVISI 3+4+4+4",
    "SBA63 GV PIANI DIVISI 4+4+4+4",
    "SBA63 R MAXI 1+2",
    "SBA63 R MAXI 2+2",
    "SBA63 R MAXI 2+3",
    "SBA63 R MAXI 3+3",
    "SBA63 R MAXI 3+4",
    "SBA32 2 PIANI FISSI",
    "SBA63 2 PIANI FISSI",
    "SBA63 R MAXI 2 PIANI FISSI",
    "SBA33-DIR CANADA 2P",
    "SBA33-DIR CANADA 3P",
    "SBA33-DIR CANADA 4P",
    "SBA33-DIR CANADA 5P",
    "SBA33-CO 2+2 CANADA",
    "SBA33-CO 3+2 CANADA",
    "SBA33-CO 3+3 CANADA",
    "SBA33-CO 4+3 CANADA",
    "SBA33-CO 4+4 CANADA",
    "SBA33-CO 5+4 CANADA",
    "SBA73-DIR CANADA 2P",
    "SBA73-DIR CANADA 3P",
    "SBA73-DIR CANADA 4P",
    "SBA73-DIR CANADA 5P",
    "SBA73-CO 2+2 CANADA",
    "SBA73-CO 3+2 CANADA",
    "SBA73-CO 3+3 CANADA",
    "SBA73-CO 4+3 CANADA",
    "SBA73-CO 4+4 CANADA",
    "SBA73-CO 5+4 CANADA",
    "SBA72 STANDARD 2+2",
    "SBA72 STANDARD 2+3",
    "SBA72 STANDARD 3+3",
    "SBA72 STANDARD 3+4",
    "SBA72 STANDARD 4+4",
    "SBA72 STANDARD 4+5",
    "SBA72 GRAN VOLUME 2+2",
    "SBA72 GRAN VOLUME 2+3",
    "SBA72 GRAN VOLUME 3+3",
    "SBA72 GRAN VOLUME 3+4",
    "SBA72 GRAN VOLUME 4+4",
    "SBA72 GRAN VOLUME 4+5",
    "SBA72 STD PIANI DIVISI 2+2+2",
    "SBA72 STD PIANI DIVISI 2+3+3",
    "SBA72 STD PIANI DIVISI 3+3+3",
    "SBA72 STD PIANI DIVISI 3+4+4",
    "SBA72 GV PIANI DIVISI 2+2+2",
    "SBA72 GV PIANI DIVISI 2+3+3",
    "SBA72 GV PIANI DIVISI 3+3+3",
    "SBA72 GV PIANI DIVISI 3+4+4",
    "SBA72 STD PIANI DIVISI 2+2+2+2",
    "SBA72 STD PIANI DIVISI 2+3+3+3",
    "SBA72 STD PIANI DIVISI 3+3+3+3",
    "SBA72 STD PIANI DIVISI 3+4+4+4",
    "SBA72 GV PIANI DIVISI 2+2+2+2",
    "SBA72 GV PIANI DIVISI 2+3+3+3",
    "SBA72 GV PIANI DIVISI 3+3+3+3",
    "SBA72 GV PIANI DIVISI 3+4+4+4",
    "SBA63 TETTO FISSO",
    "SBA53 8.5 m",
    "SBA31 SEMIRIBASSATO MAIALINI 4+5",
    "SBA63 MAIALINI 2P",
    "SBA63 MAIALINI 3P",
    "SBA63 MAIALINI 4P",
    "RBA21 STANDARD 2P 6,5 m",
    "RBA21 STANDARD 2P 7,0 m",
    "RBA21 STANDARD 2P 7,5 m",
    "RBA21 STANDARD 3P 6,5 m",
    "RBA21 STANDARD 3P 7,0 m",
    "RBA21 STANDARD 3P 7,5 m",
    "RBA21 STANDARD 4P 6,5 m",
    "RBA21 STANDARD 4P 7,0 m",
    "RBA21 STANDARD 4P 7,5 m",
    "RBA21 GRAN VOLUME 2P 6,5 m",
    "RBA21 GRAN VOLUME 2P 7,0 m",
    "RBA21 GRAN VOLUME 2P 7,5 m",
    "RBA21 GRAN VOLUME 3P 6,5 m",
    "RBA21 GRAN VOLUME 3P 7,0 m",
    "RBA21 GRAN VOLUME 3P 7,5 m",
    "RBA21 GRAN VOLUME 4P 6,5 m",
    "RBA21 GRAN VOLUME 4P 7,0 m",
    "RBA21 GRAN VOLUME 4P 7,5 m",
    "RBA21 GV SEMIRIBASSATO 2P 6,5 m",
    "RBA21 GV SEMIRIBASSATO 2P 7,0 m",
    "RBA21 GV SEMIRIBASSATO 2P 7,5 m",
    "RBA21 GV SEMIRIBASSATO 3P 6,5 m",
    "RBA21 GV SEMIRIBASSATO 3P 7,0 m",
    "RBA21 GV SEMIRIBASSATO 3P 7,5 m",
    "RBA21 GV SEMIRIBASSATO 4P 6,5 m",
    "RBA21 GV SEMIRIBASSATO 4P 7,0 m",
    "RBA21 GV SEMIRIBASSATO 4P 7,5 m",
    "RBA22 STANDARD 2P 6,5 m",
    "RBA22 STANDARD 2P 7,0 m",
    "RBA22 STANDARD 2P 7,5 m",
    "RBA22 STANDARD 3P 6,5 m",
    "RBA22 STANDARD 3P 7,0 m",
    "RBA22 STANDARD 3P 7,5 m",
    "RBA22 STANDARD 4P 6,5 m",
    "RBA22 STANDARD 4P 7,0 m",
    "RBA22 STANDARD 4P 7,5 m",
    "RBA22 GRAN VOLUME 2P 6,5 m",
    "RBA22 GRAN VOLUME 2P 7,0 m",
    "RBA22 GRAN VOLUME 2P 7,5 m",
    "RBA22 GRAN VOLUME 3P 6,5 m",
    "RBA22 GRAN VOLUME 3P 7,0 m",
    "RBA22 GRAN VOLUME 3P 7,5 m",
    "RBA22 GRAN VOLUME 4P 6,5 m",
    "RBA22 GRAN VOLUME 4P 7,0 m",
    "RBA22 GRAN VOLUME 4P 7,5 m",
    "RBA31 STANDARD 2P 7,0 m",
    "RBA31 STANDARD 2P 7,5 m",
    "RBA31 STANDARD 2P 8,0 m",
    "RBA31 STANDARD 2P 8,5 m",
    "RBA31 STANDARD 3P 7,0 m",
    "RBA31 STANDARD 3P 7,5 m",
    "RBA31 STANDARD 3P 8,0 m",
    "RBA31 STANDARD 3P 8,5 m",
    "RBA31 STANDARD 4P 7,0 m",
    "RBA31 STANDARD 4P 7,5 m",
    "RBA31 STANDARD 4P 8,0 m",
    "RBA31 STANDARD 4P 8,5 m",
    "RBA31 GRAN VOLUME 2P 7,0 m",
    "RBA31 GRAN VOLUME 2P 7,5 m",
    "RBA31 GRAN VOLUME 2P 8,0 m",
    "RBA31 GRAN VOLUME 2P 8,5 m",
    "RBA31 GRAN VOLUME 3P 7,0 m",
    "RBA31 GRAN VOLUME 3P 7,5 m",
    "RBA31 GRAN VOLUME 3P 8,0 m",
    "RBA31 GRAN VOLUME 3P 8,5 m",
    "RBA31 GRAN VOLUME 4P 7,0 m",
    "RBA31 GRAN VOLUME 4P 7,5 m",
    "RBA31 GRAN VOLUME 4P 8,0 m",
    "RBA31 GRAN VOLUME 4P 8,5 m",
    "RBA31 GV SEMIRIBASSATO 2P 7,0 m",
    "RBA31 GV SEMIRIBASSATO 2P 7,5 m",
    "RBA31 GV SEMIRIBASSATO 2P 8,0 m",
    "RBA31 GV SEMIRIBASSATO 2P 8,5 m",
    "RBA31 GV SEMIRIBASSATO 3P 7,0 m",
    "RBA31 GV SEMIRIBASSATO 3P 7,5 m",
    "RBA31 GV SEMIRIBASSATO 3P 8,0 m",
    "RBA31 GV SEMIRIBASSATO 3P 8,5 m",
    "RBA31 GV SEMIRIBASSATO 4P 7,0 m",
    "RBA31 GV SEMIRIBASSATO 4P 7,5 m",
    "RBA31 GV SEMIRIBASSATO 4P 8,0 m",
    "RBA31 GV SEMIRIBASSATO 4P 8,5 m",
    "RBA32 STANDARD 2P 7,0 m",
    "RBA32 STANDARD 2P 7,5 m",
    "RBA32 STANDARD 2P 8,0 m",
    "RBA32 STANDARD 2P 8,5 m",
    "RBA32 STANDARD 3P 7,0 m",
    "RBA32 STANDARD 3P 7,5 m",
    "RBA32 STANDARD 3P 8,0 m",
    "RBA32 STANDARD 3P 8,5 m",
    "RBA32 STANDARD 4P 7,0 m",
    "RBA32 STANDARD 4P 7,5 m",
    "RBA32 STANDARD 4P 8,0 m",
    "RBA32 STANDARD 4P 8,5 m",
    "RBA32 GRAN VOLUME 2P 7,0 m",
    "RBA32 GRAN VOLUME 2P 7,5 m",
    "RBA32 GRAN VOLUME 2P 8,0 m",
    "RBA32 GRAN VOLUME 2P 8,5 m",
    "RBA32 GRAN VOLUME 3P 7,0 m",
    "RBA32 GRAN VOLUME 3P 7,5 m",
    "RBA32 GRAN VOLUME 3P 8,0 m",
    "RBA32 GRAN VOLUME 3P 8,5 m",
    "RBA32 GRAN VOLUME 4P 7,0 m",
    "RBA32 GRAN VOLUME 4P 7,5 m",
    "RBA32 GRAN VOLUME 4P 8,0 m",
    "RBA32 GRAN VOLUME 4P 8,5 m",
    "RBA32 GV SEMIRIBASSATO 2P 7,0 m",
    "RBA32 GV SEMIRIBASSATO 2P 7,5 m",
    "RBA32 GV SEMIRIBASSATO 2P 8,0 m",
    "RBA32 GV SEMIRIBASSATO 2P 8,5 m",
    "RBA32 GV SEMIRIBASSATO 3P 7,0 m",
    "RBA32 GV SEMIRIBASSATO 3P 7,5 m",
    "RBA32 GV SEMIRIBASSATO 3P 8,0 m",
    "RBA32 GV SEMIRIBASSATO 3P 8,5 m",
    "RBA32 GV SEMIRIBASSATO 4P 7,0 m",
    "RBA32 GV SEMIRIBASSATO 4P 7,5 m",
    "RBA32 GV SEMIRIBASSATO 4P 8,0 m",
    "RBA32 GV SEMIRIBASSATO 4P 8,5 m",
    "RBA62 STANDARD 2P 7,0 m",
    "RBA62 STANDARD 2P 7,5 m",
    "RBA62 STANDARD 2P 8,0 m",
    "RBA62 STANDARD 2P 8,5 m",
    "RBA62 STANDARD 3P 7,0 m",
    "RBA62 STANDARD 3P 7,5 m",
    "RBA62 STANDARD 3P 8,0 m",
    "RBA62 STANDARD 3P 8,5 m",
    "RBA62 STANDARD 4P 7,0 m",
    "RBA62 STANDARD 4P 7,5 m",
    "RBA62 STANDARD 4P 8,0 m",
    "RBA62 STANDARD 4P 8,5 m",
    "RBA62 GRAN VOLUME 2P 7,0 m",
    "RBA62 GRAN VOLUME 2P 7,5 m",
    "RBA62 GRAN VOLUME 2P 8,0 m",
    "RBA62 GRAN VOLUME 2P 8,5 m",
    "RBA62 GRAN VOLUME 3P 7,0 m",
    "RBA62 GRAN VOLUME 3P 7,5 m",
    "RBA62 GRAN VOLUME 3P 8,0 m",
    "RBA62 GRAN VOLUME 3P 8,5 m",
    "RBA62 GRAN VOLUME 4P 7,0 m",
    "RBA62 GRAN VOLUME 4P 7,5 m",
    "RBA62 GRAN VOLUME 4P 8,0 m",
    "RBA62 GRAN VOLUME 4P 8,5 m",
    "RBA63 R MAXI 2P 8.0 m",
    "RBA63 R MAXI 2P 8.5 m",
    "RBA63 R MAXI 3P 8.0 m",
    "RBA63 R MAXI 3P 8.5 m",
    "RBA63 R MAXI 4P 8.0 m",
    "RBA63 R MAXI 4P 8.5 m",
    "RBA72 STANDARD 8,0-10,0 m 2P",
    "RBA72 STANDARD 8,0-10,0 m 3P",
    "RBA72 STANDARD 8,0-10,0 m 4P",
    "RBA72 STANDARD 8,0-10,0 m 5P",
    "RBA72 GRAN VOLUME 8,0-10,0 m 2P",
    "RBA72 GRAN VOLUME 8,0-10,0 m 3P",
    "RBA72 GRAN VOLUME 8,0-10,0 m 4P",
    "RBA72 GRAN VOLUME 8,0-10,0 m 5P",
    "RBA72 STD 8,0-10,0 PIANI DIVISI 2+2",
    "RBA72 STD 8,0-10,0 PIANI DIVISI 3+3",
    "RBA72 STD 8,0-10,0 PIANI DIVISI 4+4",
    "RBA72 GV 8,0-10,0 PIANI DIVISI 2+2",
    "RBA72 GV 8,0-10,0 PIANI DIVISI 3+3",
    "RBA72 GV 8,0-10,0 PIANI DIVISI 4+4",
    "RBA72 STD 8,0-10,0 PIANI DIVISI 2+2+2",
    "RBA72 STD 8,0-10,0 PIANI DIVISI 3+3+3",
    "RBA72 STD 8,0-10,0 PIANI DIVISI 4+4+4",
    "RBA72 GV 8,0-10,0 PIANI DIVISI 2+2+2",
    "RBA72 GV 8,0-10,0 PIANI DIVISI 3+3+3",
    "RBA72 GV 8,0-10,0 PIANI DIVISI 4+4+4",
    "RBA72 STANDARD 10,5-12,5 m 2P",
    "RBA72 STANDARD 10,5-12,5 m 3P",
    "RBA72 STANDARD 10,5-12,5 m 4P",
    "RBA72 STANDARD 10,5-12,5 m 5P",
    "RBA72 GRAN VOLUME 10,5-12,5 m 2P",
    "RBA72 GRAN VOLUME 10,5-12,5 m 3P",
    "RBA72 GRAN VOLUME 10,5-12,5 m 4P",
    "RBA72 GRAN VOLUME 10,5-12,5 m 5P",
    "RBA72 STD 10,5-12,5 PIANI DIVISI 2+2",
    "RBA72 STD 10,5-12,5 PIANI DIVISI 3+3",
    "RBA72 STD 10,5-12,5 PIANI DIVISI 4+4",
    "RBA72 GV 10,5-12,5 PIANI DIVISI 2+2",
    "RBA72 GV 10,5-12,5 PIANI DIVISI 3+3",
    "RBA72 GV 10,5-12,5 PIANI DIVISI 4+4",
    "RBA72 STD 10,5-12,5 PIANI DIVISI 2+2+2",
    "RBA72 STD 10,5-12,5 PIANI DIVISI 3+3+3",
    "RBA72 STD 10,5-12,5 PIANI DIVISI 4+4+4",
    "RBA72 GV 10,5-12,5 PIANI DIVISI 2+2+2",
    "RBA72 GV 10,5-12,5 PIANI DIVISI 3+3+3",
    "RBA72 GV 10,5-12,5 PIANI DIVISI 4+4+4",
    "RBA92 STANDARD 11,0-13,6 m 2P",
    "RBA92 STANDARD 11,0-13,6 m 3P",
    "RBA92 STANDARD 11,0-13,6 m 4P",
    "RBA92 STANDARD 11,0-13,6 m 5P",
    "RBA92 GRAN VOLUME 11,0-13,6 m 2P",
    "RBA92 GRAN VOLUME 11,0-13,6 m 3P",
    "RBA92 GRAN VOLUME 11,0-13,6 m 4P",
    "RBA92 GRAN VOLUME 11,0-13,6 m 5P",
    "RBA92 STD 11,0-13,6,0 PIANI DIVISI 2+2",
    "RBA92 STD 11,0-13,6,0 PIANI DIVISI 3+3",
    "RBA92 STD 11,0-13,6,0 PIANI DIVISI 4+4",
    "RBA92 GV 11,0-13,6,0 PIANI DIVISI 2+2",
    "RBA92 GV 11,0-13,6,0 PIANI DIVISI 3+3",
    "RBA92 GV 11,0-13,6,0 PIANI DIVISI 4+4",
    "RBA92 STD 11,0-13,6,0 PIANI DIVISI 2+2+2",
    "RBA92 STD 11,0-13,6,0 PIANI DIVISI 3+3+3",
    "RBA92 STD 11,0-13,6,0 PIANI DIVISI 4+4+4",
    "RBA92 GV 11,0-13,6,0 PIANI DIVISI 2+2+2",
    "RBA92 GV 11,0-13,6,0 PIANI DIVISI 3+3+3",
    "RBA92 GV 11,0-13,6,0 PIANI DIVISI 4+4+4",
    "BBA22 STANDARD 2P 7,0 m",
    "BBA22 STANDARD 2P 7,5 m",
    "BBA22 STANDARD 2P 8,0 m",
    "BBA22 STANDARD 2P 8,5 m",
    "BBA22 STANDARD 3P 7,0 m",
    "BBA22 STANDARD 3P 7,5 m",
    "BBA22 STANDARD 3P 8,0 m",
    "BBA22 STANDARD 3P 8,5 m",
    "BBA22 STANDARD 4P 7,0 m",
    "BBA22 STANDARD 4P 7,5 m",
    "BBA22 STANDARD 4P 8,0 m",
    "BBA22 STANDARD 4P 8,5 m",
    "BBA22 GRAN VOLUME 2P 7,0 m",
    "BBA22 GRAN VOLUME 2P 7,5 m",
    "BBA22 GRAN VOLUME 2P 8,0 m",
    "BBA22 GRAN VOLUME 2P 8,5 m",
    "BBA22 GRAN VOLUME 3P 7,0 m",
    "BBA22 GRAN VOLUME 3P 7,5 m",
    "BBA22 GRAN VOLUME 3P 8,0 m",
    "BBA22 GRAN VOLUME 3P 8,5 m",
    "BBA22 GRAN VOLUME 4P 7,0 m",
    "BBA22 GRAN VOLUME 4P 7,5 m",
    "BBA22 GRAN VOLUME 4P 8,0 m",
    "BBA22 GRAN VOLUME 4P 8,5 m",
    "BBA32 STANDARD 2P 7,0 m",
    "BBA32 STANDARD 2P 7,5 m",
    "BBA32 STANDARD 2P 8,0 m",
    "BBA32 STANDARD 2P 8,5 m",
    "BBA32 STANDARD 3P 7,0 m",
    "BBA32 STANDARD 3P 7,5 m",
    "BBA32 STANDARD 3P 8,0 m",
    "BBA32 STANDARD 3P 8,5 m",
    "BBA32 STANDARD 4P 7,0 m",
    "BBA32 STANDARD 4P 7,5 m",
    "BBA32 STANDARD 4P 8,0 m",
    "BBA32 STANDARD 4P 8,5 m",
    "BBA32 GRAN VOLUME 2P 7,0 m",
    "BBA32 GRAN VOLUME 2P 7,5 m",
    "BBA32 GRAN VOLUME 2P 8,0 m",
    "BBA32 GRAN VOLUME 2P 8,5 m",
    "BBA32 GRAN VOLUME 3P 7,0 m",
    "BBA32 GRAN VOLUME 3P 7,5 m",
    "BBA32 GRAN VOLUME 3P 8,0 m",
    "BBA32 GRAN VOLUME 3P 8,5 m",
    "BBA32 GRAN VOLUME 4P 7,0 m",
    "BBA32 GRAN VOLUME 4P 7,5 m",
    "BBA32 GRAN VOLUME 4P 8,0 m",
    "BBA32 GRAN VOLUME 4P 8,5 m",
    "MOTRICI STANDARD 2P 5,5 m",
    "MOTRICI STANDARD 2P 6,0 m",
    "MOTRICI STANDARD 2P 6,5 m",
    "MOTRICI STANDARD 2P 7,0 m",
    "MOTRICI STANDARD 2P 7,5 m",
    "MOTRICI STANDARD 2P 8,0 m",
    "MOTRICI STANDARD 2P 8,5 m",
    "MOTRICI STANDARD 2P 9,0 m",
    "MOTRICI STANDARD 2P 9,5 m",
    "MOTRICI STANDARD 3P 5,5 m",
    "MOTRICI STANDARD 3P 6,0 m",
    "MOTRICI STANDARD 3P 6,5 m",
    "MOTRICI STANDARD 3P 7,0 m",
    "MOTRICI STANDARD 3P 7,5 m",
    "MOTRICI STANDARD 3P 8,0 m",
    "MOTRICI STANDARD 3P 8,5 m",
    "MOTRICI STANDARD 3P 9,0 m",
    "MOTRICI STANDARD 3P 9,5 m",
    "MOTRICI STANDARD 4P 5,5 m",
    "MOTRICI STANDARD 4P 6,0 m",
    "MOTRICI STANDARD 4P 6,5 m",
    "MOTRICI STANDARD 4P 7,0 m",
    "MOTRICI STANDARD 4P 7,5 m",
    "MOTRICI STANDARD 4P 8,0 m",
    "MOTRICI STANDARD 4P 8,5 m",
    "MOTRICI STANDARD 4P 9,0 m",
    "MOTRICI STANDARD 4P 9,5 m",
    "MOTRICI STD PIANI DIVISI 2+2P 7,0 m",
    "MOTRICI STD PIANI DIVISI 2+2P 7,5 m",
    "MOTRICI STD PIANI DIVISI 2+2P 8,0 m",
    "MOTRICI STD PIANI DIVISI 2+2P 8,5 m",
    "MOTRICI STD PIANI DIVISI 2+2P 9,0 m",
    "MOTRICI STD PIANI DIVISI 2+2P 9,5 m",
    "MOTRICI STD PIANI DIVISI 3+3P 7,0 m",
    "MOTRICI STD PIANI DIVISI 3+3P 7,5 m",
    "MOTRICI STD PIANI DIVISI 3+3P 8,0 m",
    "MOTRICI STD PIANI DIVISI 3+3P 8,5 m",
    "MOTRICI STD PIANI DIVISI 3+3P 9,0 m",
    "MOTRICI STD PIANI DIVISI 3+3P 9,5 m",
    "MOTRICI STD PIANI DIVISI 4+4P 7,0 m",
    "MOTRICI STD PIANI DIVISI 4+4P 7,5 m",
    "MOTRICI STD PIANI DIVISI 4+4P 8,0 m",
    "MOTRICI STD PIANI DIVISI 4+4P 8,5 m",
    "MOTRICI STD PIANI DIVISI 4+4P 9,0 m",
    "MOTRICI STD PIANI DIVISI 4+4P 9,5 m",
    "MOTRICI STD PIANI DIVISI 2+2+2P 9,0 m",
    "MOTRICI STD PIANI DIVISI 2+2+2P 9,5 m",
    "MOTRICI STD PIANI DIVISI 3+3+3P 9,0 m",
    "MOTRICI STD PIANI DIVISI 3+3+3P 9,5 m",
    "MOTRICI STD PIANI DIVISI 4+4+4P 9,0 m",
    "MOTRICI STD PIANI DIVISI 4+4+4P 9,5 m",
    "MOTRICI GRAN VOLUME 2P 5,5 m",
    "MOTRICI GRAN VOLUME 2P 6,0 m",
    "MOTRICI GRAN VOLUME 2P 6,5 m",
    "MOTRICI GRAN VOLUME 2P 7,0 m",
    "MOTRICI GRAN VOLUME 2P 7,5 m",
    "MOTRICI GRAN VOLUME 2P 8,0 m",
    "MOTRICI GRAN VOLUME 2P 8,5 m",
    "MOTRICI GRAN VOLUME 2P 9,0 m",
    "MOTRICI GRAN VOLUME 2P 9,5 m",
    "MOTRICI GRAN VOLUME 3P 5,5 m",
    "MOTRICI GRAN VOLUME 3P 6,0 m",
    "MOTRICI GRAN VOLUME 3P 6,5 m",
    "MOTRICI GRAN VOLUME 3P 7,0 m",
    "MOTRICI GRAN VOLUME 3P 7,5 m",
    "MOTRICI GRAN VOLUME 3P 8,0 m",
    "MOTRICI GRAN VOLUME 3P 8,5 m",
    "MOTRICI GRAN VOLUME 3P 9,0 m",
    "MOTRICI GRAN VOLUME 3P 9,5 m",
    "MOTRICI GRAN VOLUME 4P 5,5 m",
    "MOTRICI GRAN VOLUME 4P 6,0 m",
    "MOTRICI GRAN VOLUME 4P 6,5 m",
    "MOTRICI GRAN VOLUME 4P 7,0 m",
    "MOTRICI GRAN VOLUME 4P 7,5 m",
    "MOTRICI GRAN VOLUME 4P 8,0 m",
    "MOTRICI GRAN VOLUME 4P 8,5 m",
    "MOTRICI GRAN VOLUME 4P 9,0 m",
    "MOTRICI GRAN VOLUME 4P 9,5 m",
    "MOTRICI GV PIANI DIVISI 2+2P 7,0 m",
    "MOTRICI GV PIANI DIVISI 2+2P 7,5 m",
    "MOTRICI GV PIANI DIVISI 2+2P 8,0 m",
    "MOTRICI GV PIANI DIVISI 2+2P 8,5 m",
    "MOTRICI GV PIANI DIVISI 2+2P 9,0 m",
    "MOTRICI GV PIANI DIVISI 2+2P 9,5 m",
    "MOTRICI GV PIANI DIVISI 3+3P 7,0 m",
    "MOTRICI GV PIANI DIVISI 3+3P 7,5 m",
    "MOTRICI GV PIANI DIVISI 3+3P 8,0 m",
    "MOTRICI GV PIANI DIVISI 3+3P 8,5 m",
    "MOTRICI GV PIANI DIVISI 3+3P 9,0 m",
    "MOTRICI GV PIANI DIVISI 3+3P 9,5 m",
    "MOTRICI GV PIANI DIVISI 4+4P 7,0 m",
    "MOTRICI GV PIANI DIVISI 4+4P 7,5 m",
    "MOTRICI GV PIANI DIVISI 4+4P 8,0 m",
    "MOTRICI GV PIANI DIVISI 4+4P 8,5 m",
    "MOTRICI GV PIANI DIVISI 4+4P 9,0 m",
    "MOTRICI GV PIANI DIVISI 4+4P 9,5 m",
    "MOTRICI GV PIANI DIVISI 2+2+2P 9,0 m",
    "MOTRICI GV PIANI DIVISI 2+2+2P 9,5 m",
    "MOTRICI GV PIANI DIVISI 3+3+3P 9,0 m",
    "MOTRICI GV PIANI DIVISI 3+3+3P 9,5 m",
    "MOTRICI GV PIANI DIVISI 4+4+4P 9,0 m",
    "MOTRICI GV PIANI DIVISI 4+4+4P 9,5 m",
    "FURGONCINI 1P 3,5 m",
    "FURGONCINI 1P 4,0 m",
    "FURGONCINI 1P 4,5 m",
    "FURGONCINI 1P 5,0 m",
    "FURGONCINI 1P 5,5 m",
    "FURGONCINI 1P 6,0 m",
    "FURGONCINI 1P 6,5 m",
    "CISTERNA 4 CELLE",
    "CISTERNA 5 CELLE"
];
